export enum FacilityFilter {
  ALL = 'ALL',
  STATIONS = 'STATIONS',
  PARKING_FACILITIES = 'PARKING_FACILITIES',
}
